import { useTranslation } from "react-i18next";
import type { AnalyticsSnapshotResponse } from "@/features/admin/adminAnalytics.types";
import { GenericAnalyticsTab } from "@/features/admin/components/analytics/GenericAnalyticsTab";

export function UsersAccountsAnalyticsTab({ loading, snapshot }: { loading?: boolean; snapshot: AnalyticsSnapshotResponse | null }) {
  const { t } = useTranslation();
  return (
    <GenericAnalyticsTab
      loading={loading}
      panels={[
        { chart: "line", metricKey: "new_registrations", series: ["total"], title: t("adminWorkspace.analytics.users.registrations") },
        { chart: "bar", metricKey: "new_registrations_by_tier", series: ["free", "crafter", "author"], title: t("adminWorkspace.analytics.users.registrationsByTier") },
        { chart: "line", metricKey: "accounts_marked_for_deletion", series: ["total"], title: t("adminWorkspace.analytics.users.markedForDeletion") },
        { chart: "line", metricKey: "accounts_pending_deletion", series: ["total"], title: t("adminWorkspace.analytics.users.pendingDeletion") },
        { chart: "line", metricKey: "accounts_soft_deleted", series: ["total"], title: t("adminWorkspace.analytics.users.softDeleted") },
        { chart: "bar", metricKey: "active_subscribers_by_tier", series: ["crafter", "author"], title: t("adminWorkspace.analytics.users.tierDistribution") },
      ]}
      snapshot={snapshot}
    />
  );
}
